export const ADVISOR_TO_COMPANY = 'ADVISOR_TO_COMPANY';
export const BOARD_MEMBER_TO_COMPANY = 'BOARD_MEMBER_TO_COMPANY';
export const CONTRACTOR_TO_COMPANY = 'CONTRACTOR_TO_COMPANY';
export const MANAGER_TO_COMPANY = 'MANAGER_TO_COMPANY';
export const OWNER_TO_COMPANY = 'OWNER_TO_COMPANY';
export const PARTNER_TO_COMPANY = 'PARTNER_TO_COMPANY';
export const RESELLER_TO_COMPANY = 'RESELLER_TO_COMPANY';